import { get, post, patch, del } from '../httpMethods';
import { ApiResponse } from '../../types/api';

export interface Department {
  id: string;
  name: string;
  code: string;
  description?: string;
  status: 'ACTIVE' | 'INACTIVE';
  displayOrder: number;
  rooms?: Array<{ id: string; name: string }>;
  createdAt: string;
  updatedAt: string;
}

export interface CreateDepartmentPayload {
  name: string;
  code: string;
  description?: string;
  status?: 'ACTIVE' | 'INACTIVE';
  displayOrder?: number;
}

export const departmentService = {
  getDepartments: (page = 1, limit = 20, search?: string): Promise<ApiResponse<Department[]>> => {
    const params = new URLSearchParams({ page: String(page), limit: String(limit) });
    if (search) params.set('search', search);
    return get<Department[]>(`/departments?${params.toString()}`);
  },

  getAllDepartments: (): Promise<ApiResponse<Department[]>> => {
    return get<Department[]>('/departments?limit=1000');
  },

  createDepartment: (data: CreateDepartmentPayload): Promise<ApiResponse<Department>> => {
    return post<Department>('/departments', data);
  },

  updateDepartment: (id: string, data: Partial<CreateDepartmentPayload>): Promise<ApiResponse<Department>> => {
    return patch<Department>(`/departments/${id}`, data);
  },

  deleteDepartment: (id: string): Promise<ApiResponse<void>> => {
    return del<void>(`/departments/${id}`);
  },
};
